(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muso-reviews"] && !Shopify.designMode) return;
  try {
    
  const hydrateMusoReviewImages = () => {
    document.querySelectorAll('.muso-reviews .jdgm-carousel-item__product-image').forEach((image) => {
      if (image.getAttribute('src')) return;
      const source = image.dataset.srcRetina || image.dataset.src;
      if (!source) return;
      image.setAttribute('loading', 'eager');
      image.setAttribute('decoding', 'async');
      image.setAttribute('src', source);
    });
  };

  hydrateMusoReviewImages();
  document.addEventListener('DOMContentLoaded', hydrateMusoReviewImages);
  window.addEventListener('load', hydrateMusoReviewImages);
  window.setTimeout(hydrateMusoReviewImages, 800);
  window.setTimeout(hydrateMusoReviewImages, 1800);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muso-shop-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-muso-shop-previous], [data-muso-shop-next]');

    if (!control) {
      return;
    }

    const card = control.closest('[data-muso-shop-card]');
    const slides = [...card.querySelectorAll('[data-muso-shop-slide]')];

    if (slides.length < 2) {
      return;
    }

    const currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    const direction = control.matches('[data-muso-shop-previous]') ? -1 : 1;
    const nextIndex = (currentIndex + direction + slides.length) % slides.length;

    slides[currentIndex]?.classList.remove('is-active');
    slides[nextIndex].classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();
})();
